import paddingDefault from '@utils/paddingDefault';
import { graphql } from 'gatsby';
import React from 'react';
import { useMicrosite } from '../../contexts/franchise/microsite-context';
import Container from '../atoms/Container';
import ServiceTypesIcons from '../molecules/service-types-icons';
import ServiceTypesText from '../molecules/service-types-text';
import { StyledButtonAsLink } from '../primitives/styled-button';
import { colors } from '../primitives/colors';

const ServicesWeProvide = ({ data, visitSiteCtaHref }) => {
    const { title } = data || {};
    const { franchise: { servicesProvided }, permalink } = useMicrosite();

    if (!servicesProvided || servicesProvided.length === 0) return null;

    return (
        <div

            css={[paddingDefault(), styles.background]}
        >
            <Container>
                <h2
                    css={styles.franchisePageHeading}
                >
                    {title}
                </h2>
                <div css={styles.servicesWrap}
                >
                    <ServiceTypesIcons
                        servicesProvided={servicesProvided}
                        permalink={permalink}
                    />
                    <ServiceTypesText
                        heading="Additional Services"
                        servicesProvided={servicesProvided}
                        css={styles.serviceTypesText}
                        permalink={permalink}
                    />
                </div>
                {visitSiteCtaHref && (
                    <div css={styles.buttonWrap}>
                        <StyledButtonAsLink to={visitSiteCtaHref}>
                            Visit Our Site
                        </StyledButtonAsLink>
                    </div>
                )}
            </Container>
        </div>
    );
};

const styles = {
    franchisePageHeading: {
        fontSize: "36px",
        marginBottom: '32px',
        lineHeight: 1.25,
        "@media (min-width: 1024px)": {
            marginBottom: "1.5rem",
        }
    },
    background: {
        backgroundColor: colors.shadesWhite,
    },
    serviceTypesText: {
        marginTop: '32px',
    },
    servicesWrap: {
        marginTop: '24px',
    },
    buttonWrap: {
        marginTop: '32px',
    }
};

export const query = graphql`
    fragment ServicesWeProvideData on CmsPageBuilderBlocks {
        services_we_provide {
            title
        }
    }
`;

export default ServicesWeProvide;
